module.exports = __webpack_public_path__ + "677e2221f08fddaced367982b00ffc63.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/3000_12_teaser_image.jpg
// module id = 612
// module chunks = 0